import React from 'react';
import { KeenIcon } from '@/components';

const IntroImage = () => (
  <div className="mb-3">
    <label className="block text-sm font-bold mb-1">Intro Image <span className="text-xs text-gray-500">(1080x1920)</span></label>
    <div className="flex items-center gap-2 mb-2">
      <input type="checkbox" id="enable-intro-image" className="mr-2" />
      <label htmlFor="enable-intro-image" className="text-sm">Enable File Intro Image</label>
    </div>
    <div className="flex gap-2">
      <div className="w-20 h-20 border-2 border-dashed rounded flex items-center justify-center text-2xl text-gray-400">
        +
      </div>
      <button className="flex-1 border rounded px-3 py-2 flex items-center gap-2 hover:bg-gray-100 transition-colors text-left">
        <KeenIcon icon="paper-clip" className="text-6xl"/> Upload for file image
      </button>
    </div>
  </div>
);

export { IntroImage };
